export const MIN_PASSWORD = 12;
export const MAX_PASSWORD = 128;

/** A message when the new password cannot be used, otherwise null. The server checks again; this only saves a round trip. */
export function passwordProblem(current: string, next: string, confirm: string): string | null {
  if (current === '') return 'Enter your current password.';
  if (next.length < MIN_PASSWORD) return `The new password must be at least ${MIN_PASSWORD} characters.`;
  if (next.length > MAX_PASSWORD) return `The new password can be at most ${MAX_PASSWORD} characters.`;
  if (next === current) return 'The new password must be different from the current one.';
  if (next !== confirm) return 'The two new passwords do not match.';
  return null;
}
